import { render, staticRenderFns } from "./ChatIconHoverNew.vue?vue&type=template&id=ae370d4c"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae370d4c')) {
      api.createRecord('ae370d4c', component.options)
    } else {
      api.reload('ae370d4c', component.options)
    }
    module.hot.accept("./ChatIconHoverNew.vue?vue&type=template&id=ae370d4c", function () {
      api.rerender('ae370d4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/ChatIconHoverNew.vue"
export default component.exports